import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
    selector: 'app-section-form-wrapper',
    templateUrl: './section-form-wrapper.html',
    styleUrl: './section-form-wrapper.scss',
    standalone: true,
    imports: [MatIconModule, CommonModule, MatButtonModule, MatTooltipModule ]
})
export class SectionFormWrapper extends FieldWrapper {

    onExpand() {
        let state: any = super.options?.formState
        state[this.props['idexpand']] = !state[this.props['idexpand']]
        super.props['expand'] = !state[this.props['idexpand']]
    }

}
